// @flow

import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  setBulkEmailStatus,
  setBulkEmailToInitial,
  startRemovingAllAttachments
} from 'actions/bulkEmail';
import usePageTitle from 'hooks/usePageTitle';
import { When } from 'UI/components/atoms/When';
import AddEmailOptInForm from 'UI/components/organisms/AddEmailOptInForm';
import BulkEmailDrawer from 'UI/components/organisms/BulkEmailDrawer';
import BulkEmailLayout from 'UI/components/templates/BulkEmailLayout';
import { PageTitles } from 'UI/constants/defaults';

const BulkEmail = () => {
  usePageTitle({ title: PageTitles.BulkEmail });
  const dispatch = useDispatch();

  const [uiState, setUiState] = useState({
    isOptOutDrawerOpen: false,
    isBulkEmailDrawerOpen: false,
    shouldComposeBulkSequence: false
  });

  useEffect(
    () => () => {
      dispatch(setBulkEmailToInitial());
      dispatch(startRemovingAllAttachments());
      dispatch(setBulkEmailStatus({ loadLast: false, reloadEmailList: false }));
    },
    [dispatch]
  );

  const onAddEmailToOptOut = () =>
    setUiState(prevState => ({ ...prevState, isOptOutDrawerOpen: true }));

  const toggleDrawer = (drawer: string, open) => event => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setUiState(prevState => ({ ...prevState, [drawer]: open }));
  };

  const handleOpenBulkForm = (
    { shouldComposeBulkSequence } = { shouldComposeBulkSequence: false }
  ) => setUiState(prev => ({ ...prev, isBulkEmailDrawerOpen: true, shouldComposeBulkSequence }));

  const handleCloseBulkEmailDrawer = useCallback(() => {
    setUiState(prev => ({
      ...prev,
      isBulkEmailDrawerOpen: false,
      shouldComposeBulkSequence: false
    }));
  }, []);

  return (
    <>
      <BulkEmailLayout
        isBulk
        onOpenBulkForm={handleOpenBulkForm}
        onAddEmailToOptOut={onAddEmailToOptOut}
      />
      {uiState.isBulkEmailDrawerOpen && (
        <BulkEmailDrawer
          onCloseDrawer={handleCloseBulkEmailDrawer}
          loadLastBulkEmail
          shouldComposeBulkSequence={uiState.shouldComposeBulkSequence}
        />
      )}

      <When condition={uiState.isOptOutDrawerOpen}>
        <AddEmailOptInForm
          FPDrawerProps={{ open: uiState.isOptOutDrawerOpen }}
          onClosed={toggleDrawer('isOptOutDrawerOpen', false)}
        />
      </When>
    </>
  );
};

export default BulkEmail;
